import { FC, ReactNode } from "react";

import { Container, Content, IconContainer, Message, Title, WarningIcon } from "./styles";

interface IProps {
  showIcon?: boolean;
  title?: ReactNode;
  message?: ReactNode;
  bottomContent?: ReactNode;
  children?: ReactNode;
  className?: string;
  alt?: boolean;
}

const EmphasizedSection: FC<IProps> = ({
  showIcon = true,
  title,
  message,
  bottomContent,
  children,
  className,
  alt,
}) => {
  return (
    <Container className={className} alt={alt}>
      {showIcon && (
        <IconContainer>
          <WarningIcon />
        </IconContainer>
      )}
      <Content>
        {children || (
          <>
            {title && <Title>{title}</Title>}
            {message && <Message>{message}</Message>}
            {bottomContent}
          </>
        )}
      </Content>
    </Container>
  );
};

export default EmphasizedSection;
